import { TouchableOpacity } from 'react-native'
import styled, { useTheme } from 'styled-components'
import Icon from '@flix/common/elements/images/Icon'

const SendButtonWrapper = styled(TouchableOpacity)`
  flex-shrink: 0;
  padding: 0 ${(props) => props.theme.spacing.sm}px;
`

export const SendButton = ({ onPress }) => {
  const theme = useTheme()
  return (
    <SendButtonWrapper onPress={onPress}>
      <Icon name="send" color={theme.colors.grayDarker} />
    </SendButtonWrapper>
  )
}
